<template>
  <div class="menu-wrapper">
    <template v-for="item in routesList">
      <router-link
        v-if="
          item.children.length === 1 &&
            !item.children[0].children &&
            !item.alwaysShow
        "
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item
          :index="item.path + '/' + item.children[0].path"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <ig-icon
            class="svg-icon"
            v-if="item.children[0].meta && item.children[0].meta.icon"
            :name="item.children[0].meta.icon"
          ></ig-icon>
          <span v-if="item.children[0].meta && item.children[0].meta.title">{{
            item.children[0].meta.title
          }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu
        v-else
        :index="item.name || item.path"
        :key="item.name"
      >
        <template slot="title">
          <ig-icon
            class="svg-icon"
            v-if="item.meta && item.meta.icon"
            :name="item.meta.icon"
          ></ig-icon>
          <span v-if="item.meta && item.meta.title">{{
            item.meta.title
          }}</span>
        </template>

        <template
          v-for="child in item.children"
          v-if="!child.hidden && !child.hideNav"
        >
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <ig-icon
                class="svg-icon"
                v-if="child.meta && child.meta.icon"
                :name="child.meta.icon"
              ></ig-icon>
              <span v-if="child.meta && child.meta.title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    routesList() {
      return this.routes.filter(
        (item) => !item.hidden && item.children && !item.hideNav
      )
    },
  },
  methods: {},
}
</script>
<style lang="scss">
.menu-wrapper .svg-icon {
  color: #bfcedd;
}
</style>
